<template>
  <div class="row">
    <div class="col-xs-12 product-cart-form">
      <form @submit.prevent="submit">
        <input
          id="quantity"
          ref="quantityInput"
          type="number"
          class="product-quantity-input form-control"
          value="1"
          min="1"
        />
        <submit-button
          :loading="loading"
          :default-label="buttonDefaultLabel"
          :loading-label="buttonLoadingLabel"
        />
      </form>
    </div>
    <div class="col-xs-12 add-to-cart-notifications">
      <alert-box
        v-for="(alert, i) in alerts"
        :key="i"
        :message="alert.message"
        :type="alert.type"
      >
        {{ alert.message }}
      </alert-box>
      <add-to-cart-modal
        ref="modal"
        :title="responseData.title"
        :variant="variantAdded"
        :order="responseData.order"
        :continue-shopping-label="continueShoppingLabel"
        :cart-heading="modalCartHeading"
        :total-label="modalTotalLabel"
        :view-cart-label="viewCartLabel"
        :warnings="responseData.warnings"
      />
    </div>
  </div>
</template>

<script>
  import axios from "axios"
  import alerts from "mixins/storefront/cart-alerts"
  import updateCart from "mixins/storefront/update-cart"
  import SubmitButton from "./submit-button.vue"
  import AddToCartModal from "./add-to-cart/modal.vue"

  export default {
    components: {
      SubmitButton,
      AddToCartModal
    },
    mixins: [alerts, updateCart],
    props: {
      url: { type: String, required: true },
      buttonDefaultLabel: { type: String, default: "Add to Cart" },
      buttonLoadingLabel: { type: String, default: "Adding to Cart ..." },
      modalCartHeading: { type: String, default: "Cart info" },
      modalTotalLabel: { type: String, default: "Order Subtotal" },
      continueShoppingLabel: { type: String, default: "Continue shopping" },
      viewCartLabel: { type: String, default: "View Cart" }
    },
    data() {
      return {
        loading: false,
        variantAdded: null,
        responseData: {
          order: {}
        }
      }
    },
    methods: {
      submit() {
        const variants = {}
        const variantId = this.getSelectedVariantId()
        const quantity = this.$refs.quantityInput.value
        variants[variantId] = quantity

        this.alerts = []
        this.loading = true

        axios.post(this.url, { variants })
          .then((response) => {
            this.$refs.quantityInput.value = 1

            switch (response.status) {
              case 200:
                this.responseData = response.data
                if (response.data.items_added.length > 0) {
                  this.variantAdded = response.data.items_added[0].variant
                }
                this.$refs.modal.open()
                this.updateCart(response.data.order)
                this.csTrack(response.data.items_added)
                break
              case 422:
                response.data.errors.forEach((error) => {
                  this.alert(error, "danger")
                })
                break
              default:
                break
            }
          })
          .catch((error) => {
            if (error.response && error.response.data) {
              error.response.data.errors.forEach((message) => {
                this.alert(message, "danger")
              })
            } else {
              this.alert(error.message || error, "danger")
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      getSelectedVariantId() {
        const variantSelect = document.querySelectorAll(
          'input[name="variant_id"]'
        )
        if (variantSelect.length > 1) {
          const checkedVariant = Array.from(variantSelect).filter(
            (node) => node.checked
          )[0]
          return checkedVariant.value
        }
        return variantSelect[0].value
      },
      csTrack(itemsAdded) {
        // GA Enhanced Ecommerce - Add to Cart
        // https://developers.google.com/tag-manager/enhanced-ecommerce#cart
        cs.dataLayer.push(
          {
            event: "addToCart",
            ecommerce: {
              add: {
                products: itemsAdded.map((item) => {
                  return {
                    id: item.variant.sku,
                    name: item.variant.product_name,
                    category: item.variant.ga_category,
                    variant: item.variant.name,
                    price: item.variant.price,
                    quantity: item.quantity
                  }
                })
              }
            }
          }
        )
      }
    }
  }
</script>
